import { dimensions, fontFamily, palette } from "../styles/foundation";
import styled from "styled-components";

// Atoms
export const uiFooter = {
  Footer: styled.footer`
    margin: 0 auto;

    /* responsive */
    font-size: 1.2rem;
    padding: 28px 25px 35px 25px;
    @media (min-width: ${dimensions.breakPoint + 1}px) {
      font-size: 1.6rem;
      max-width: 1180px;
      padding: 59px 40px 80px 40px;
    }
  `,
  LogoContainer: styled.div`
    display: flex;
    flex-wrap: nowrap;

    & > svg {
      width: 25px;
      max-height: 49px;
    }

    /* responsive */
    margin-bottom: 5px;
    @media (min-width: ${dimensions.breakPoint + 1}px) {
      margin-bottom: 15px;
      & > svg {
        width: 35px;
      }
    }
  `,
  Name: styled.div`
    font-family: ${fontFamily.serif};

    /* responsive */
    line-height: 1.5;
    margin-left: 10px;
    @media (min-width: ${dimensions.breakPoint + 1}px) {
      font-size: 1.5rem;
      line-height: 1.6;
      margin-left: 20px;
    }
  `,
  ContactContainer: styled.div`
    /* responsive */
    margin-bottom: 20px;
    @media (min-width: ${dimensions.breakPoint + 1}px) {
      display: flex;
      padding: 0;
      & > div:first-child {
        margin-right: 50px;
      }
    }
  `,
  TelContainer: styled.div`
    display: flex;
    font-family: ${fontFamily.serif};
    @media all and (-ms-high-contrast: none) {
      font-family: ${fontFamily.serif_ie11};
    }

    /* responsive */
    font-size: 1.5rem;
    line-height: 1.4;
    margin-bottom: 12px;
    & > svg {
      width: 15px;
      height: 11px;
      margin-top: 0.4rem;
      margin-right: 1rem;
    }
    @media (min-width: ${dimensions.breakPoint + 1}px) {
      font-size: 1.9rem;
      line-height: 1.3;
      margin-bottom: 15px;
      & > svg {
        width: 20px;
        height: 15px;
        margin-right: 1rem;
      }
    }
  `,
  TelInnerContainer: styled.div``,
  Tel: styled.div`
    @media (min-width: ${dimensions.breakPoint + 1}px) {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
    }
  `,
  TelLink: styled.a`
    margin-right: 5px;
    @media (min-width: ${dimensions.breakPoint + 1}px) {
      letter-spacing: 0.2rem;
    }
  `,
  TelAnnotation: styled.span`
    font-size: 1.3rem;
    @media (min-width: ${dimensions.breakPoint + 1}px) {
      font-size: 1.6rem;
    }
  `,
  MailIconContainer: styled.div`
    display: flex;
    font-family: ${fontFamily.serif};
    align-items: center;
    letter-spacing: 0;
    @media all and (-ms-high-contrast: none) {
      font-family: ${fontFamily.serif_ie11};
    }

    /* responsive */
    font-size: 1.5rem;
    line-height: 1.4;
    & > svg {
      width: 15px;
      height: 12px;
      margin-right: 1rem;
    }
    @media (min-width: ${dimensions.breakPoint + 1}px) {
      font-size: 1.9rem;
      line-height: 1.3;
      margin-bottom: 3px;
      letter-spacing: 0.1rem;
      & > svg {
        width: 20px;
        height: 15px;
        margin-right: 1rem;
      }
    }
  `,
  LinkContainer: styled.nav`
    /* responsive */
    @media (min-width: ${dimensions.breakPoint + 1}px) {
      display: flex;
      justify-content: space-between;
    }
  `,
  LinkList: styled.nav`
    display: flex;
    list-style-type: none;
    padding: 0;
    flex-wrap: wrap;

    /* responsive */
    margin-bottom: 12px;
    @media (min-width: ${dimensions.breakPoint + 1}px) {
      margin-bottom: 0;
    }
  `,
  LinkGroup1: styled.div`
    & > a:not(:last-child) {
      border-right: 1px solid ${palette.ink.normal};
      margin-right: 7px;
      padding-right: 7px;
    }
    @media (min-width: ${dimensions.breakPoint + 1}px) {
      & > a {
        border-right: 1px solid ${palette.ink.normal};
        margin-right: 7px;
        padding-right: 7px;
      }
    }
  `,
  LinkGroup2: styled.div`
    & > a:not(:last-child) {
      border-right: 1px solid ${palette.ink.normal};
      margin-right: 7px;
      padding-right: 7px;
    }
  `,
  Copyright: styled.div`
    font-size: 1.1rem;
    @media (min-width: ${dimensions.breakPoint + 1}px) {
      white-space: nowrap;
    }
  `,
  Address: styled.address`
    margin-bottom: 5px;
    @media (min-width: ${dimensions.breakPoint + 1}px) {
      margin-bottom: 0;
    }
  `,
  // Annotation: styled.div`
  //   margin-top: 8px;
  //   @media (min-width: ${dimensions.breakPoint + 1}px) {
  //     margin-top: 10px;
  //   }
  // `,
};
